import React from 'react'
import Styled from 'styled-components'
import { Fragment, useState, useEffect, useContext } from "react"

const SelectStyled = Styled.select`

    &.dropdown{
        position: relative;
        padding: 0.8rem 2rem 0.8rem 1rem;
        border: thin solid  ${(props) => props.theme.main.mainPurple};
        font-size: 1.2rem;
        color:  ${(props) => props.theme.main.mainPurple};
        width: 100%;
        border-radius: 0px;
        appearance: none;
    }
`
const Dropdown = (props: any) => {

    const [selected, setSelected] = useState(null);

    if (selected != props.value) {
        setSelected(props.value)
    }

    const ChangeSelect = (e: any) => {
        const option = props.options.find((each: any) => each.value == e.target.value)
        setSelected(option)
        props.onChange(option)
    }

    return < SelectStyled
        value={!!selected ? selected.value : ''}
        className={`dropdown ${props.Class ? props.className : ''}`}
        onChange={ChangeSelect} >
        {
            props.options &&
            props.options.map((each: any) => {
                return <option key={each.key}>
                    {each.value}
                </option>
            })
                .concat(
                    <option key={props.options.length + 1} value='' disabled hidden>
                        {props.placeholder}
                    </option>)
        }
    </SelectStyled >
}

export default Dropdown